import { render, staticRenderFns } from "./LiteratureCartExternal.vue?vue&type=template&id=e2834e6c&"
import script from "./LiteratureCartExternal.vue?vue&type=script&lang=js&"
export * from "./LiteratureCartExternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports